import React from "react";
import "./footer.css";
import Social from "../NavbarContainer/Social";
import {Link} from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row footer__main justify-content-center align-items-start">
          <div className="col-lg-2 col-4 mb-2 mb-lg-0">
            <Link to="/">
              <svg
                className="footer__logo"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 590.3 599.1"
              >
                <path
                  className="footer__logo--path"
                  d="M531 428.6V43c0-4.9-.9-9.7-2.4-14.1C523.3 14.7 510 3.2 494.8.6h-.5c-2-.4-4.2-.6-6.3-.6H102.3c-23.7 0-43 19.3-43 43v385.6c0 4.9.9 9.7 2.4 14.1 5.3 14.2 18.6 25.8 33.8 28.3h.4c2.1.3 4.2.5 6.4.5h164.6L110 269.6h83.5l156.9 202h50.2l-156.9-202h98.1c17.2 0 29.7-4.1 38.3-12.6 8.5-8.5 12.7-20.9 12.7-37.8 0-24.7-7.4-50-62-50H165.6L114 102.8h230c36.3 0 65.8 10.7 87.6 31.9 22 21.3 33.1 50.1 33.1 85.5 0 32.3-10 59-29.7 79.4-14.2 14.7-33.1 25.1-56.2 31l105.3 141h3.9c23.6 0 43-19.3 43-43z"
                ></path>
                <path
                  className="footer__logo--path"
                  d="M33.2 555.1H18.6l-7.7 43.5H6.8l7.7-43.5H0l.7-4.1h33.2l-.7 4.1zM87.8 551l-8.4 47.6h-4.1l4-22.8H55l-4 22.8h-4.1l8.4-47.6h4.1l-3.6 20.7H80l3.6-20.7h4.2zM118.6 550.9l-8.4 47.7H106l8.4-47.7h4.2zM136.8 598.6l8.4-47.6h4.5l17.4 40.2 7.1-40.2h4.1l-8.4 47.6h-4.5l-17.3-40.2-7.1 40.2h-4.2zM204.9 551h4.1l-3.9 22 27.9-22h6.2L209 574.8l21.9 23.8h-6l-20.4-22.1-3.9 22.1h-4.1l8.4-47.6zM284.6 598.6L293 551h20.9c3.5 0 6.1 1.1 7.5 3.3 1.5 2.2 1.9 5.2 1.2 9.1-.4 2.2-1.1 4.2-2.1 5.8-1 1.7-2.3 3.1-3.8 4.2.5.4 1.1.9 1.6 1.4.5.6 1 1.3 1.4 2.1.4.9.6 1.9.7 3 .1 1.2 0 2.5-.2 4.1-.8 4.6-2.4 8.2-4.9 10.7-2.4 2.5-5.7 3.8-9.8 3.8h-20.9zm8.9-26.9h16.8c2.2 0 4.1-.8 5.4-2.3 1.4-1.5 2.3-3.5 2.7-6 .5-2.7.3-4.8-.5-6.2-.8-1.4-2.4-2.1-4.8-2.1h-16.7l-2.9 16.6zm-4 22.8h16.7c.6 0 1.3-.1 2.3-.2.9-.1 1.9-.5 2.9-1.1 1-.6 1.9-1.7 2.7-3.1.9-1.4 1.5-3.4 2-6 .5-2.8.2-4.9-1-6.3-1.1-1.4-3-2-5.6-2h-16.7l-3.3 18.7zM379.3 555.1h-27.1l-2.9 16.6h19.5l-.7 4.1h-19.5l-3.3 18.7h27.1l-.7 4.1h-31.3l8.4-47.6H380l-.7 4.1zM407.4 598.6h-4.1l4-22.7-11.1-25h4.8l9.2 20.6L427 551h4.8l-20.4 25-4 22.6zM478.4 562.8l-4.2 23.8c-.7 4.2-2.7 7.3-5.8 9.4-3.1 2.1-7.4 3.1-12.7 3.1-5.3 0-9.2-1-11.6-3.1-2.4-2.1-3.3-5.2-2.5-9.4l4.2-23.8c.7-4 2.6-7.1 5.8-9.2 3.2-2.1 7.4-3.2 12.7-3.2 5.3 0 9.2 1 11.6 3.1 2.3 2.1 3.2 5.2 2.5 9.3zm-8.4 24.1l4.3-24.3c.1-.6.2-1.3.2-2.2 0-.9-.3-1.8-.9-2.6-.6-.9-1.7-1.6-3.2-2.2-1.5-.6-3.8-1-6.8-1s-5.4.3-7.2 1c-1.8.6-3.1 1.4-4 2.3-.9.9-1.5 1.8-1.8 2.7-.3.9-.5 1.6-.6 2.2l-4.3 24.1c-.1.5-.2 1.3-.2 2.2 0 .9.3 1.8.9 2.7.6.9 1.7 1.6 3.2 2.3 1.5.7 3.8 1 6.8 1s5.3-.3 7.1-1c1.8-.6 3.1-1.4 4-2.3.9-.9 1.5-1.8 1.9-2.7.3-1 .5-1.7.6-2.2zM495.4 598.6l8.4-47.6h4.5l17.4 40.2 7.1-40.2h4.1l-8.4 47.6H524l-17.3-40.2-7.1 40.2h-4.2zM560.2 551h16.3c4.9 0 8.6 1 11 3 2.4 2 3.3 4.9 2.6 8.8l-4.2 23.6c-.7 4-2.6 7-5.8 9.1-3.2 2.1-7.2 3.1-12 3.1h-16.3l8.4-47.6zm15.5 4.1h-12.1l-6.9 39.3h12.1c1.4 0 2.8-.1 4.2-.3 1.4-.2 2.7-.6 3.9-1.2 1.2-.6 2.2-1.4 3.1-2.4.9-1 1.5-2.4 1.8-4l4.2-23.6c.2-1.4.2-2.6-.2-3.6s-1.1-1.8-2-2.4c-.9-.6-2.1-1.1-3.4-1.3-1.4-.4-3-.5-4.7-.5z"
                ></path>
              </svg>
            </Link>
          </div>
          <div className="col-lg-9 ml-lg-auto d-sm-block">
            <div className="row justify-content-center m-auto">
              <div className="col-4 col-sm-4 col-md-4 col-lg-4">
                <h5 className="footer__title">Get Started</h5>
                <div className="footer__menu">
                  <ul id="menu-menu-1" className="footer__menu--list">
                    <li className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/">
                        Request Demo
                      </Link>
                    </li>
                    <li className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/">
                        Finance Options
                      </Link>
                    </li>
                    <li className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/">
                        Shop Accessories
                      </Link>
                    </li>
                    <li className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/">
                        Where to Buy
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-4 col-sm-4 col-md-4 col-lg-4">
                <h5 className="footer__title">Company</h5>
                <div className="footer__menu">
                  <ul id="menu-menu-2" className="footer__menu--list">
                    <li id="menu-item-1063" className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/">
                        Why Ricoma
                      </Link>
                    </li>
                    <li id="menu-item-1067" className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/products">
                        Machines
                      </Link>
                    </li>
                    <li id="menu-item-1066" className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/software">
                        Software
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-4 col-sm-4 col-md-4 col-lg-4">
                <h5 className="footer__title">Support</h5>
                <div className="footer__menu">
                  <ul id="menu-menu-3" className="footer__menu--list">
                    <li id="menu-item-619" className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/">
                        Embroidery Hub
                      </Link>
                    </li>
                    <li id="menu-item-624" className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/">
                        Frequently Asked Questions
                      </Link>
                    </li>
                    <li id="menu-item-1065" className="footer__menu--list-item">
                      <Link className="footer__menu--list-link" to="/contact">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row text-center footer__social m-auto mx-2">
          <div className="col mb-3">
            <Social />
          </div>
        </div>

        <div className="row justify-content-center footer__bottom">
          <div className="col text-center">
            <ul className="footer__bottom--list">
              <li className="footer__bottom--item">
                <a className="footer__bottom--link" href="/privacy">
                  Privacy Policy
                </a>
              </li>
              <li className="footer__bottom--item">
                <a
                  className="footer__bottom--link"
                  href="/terms-and-conditions"
                >
                  Terms and Conditions
                </a>
              </li>
            </ul>
            © Ricoma Qatar Embroidery Solutions 2023. Distributed by{" "}
            <Link
              className="footer__bottom--link"
              to="/"
              rel="noreferrer noopener"
              target="_blank"
            >
              RicomaQatar Embroidery Solutions.
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
